<template>
  <div
    v-if="
      props.icon !== undefined ||
      props.title !== undefined ||
      props.description !== undefined
    "
    class="flex gap-2"
    :class="{
      'flex-col items-center': props.orientation === 'vertical',
      'flex-row items-center': props.orientation === 'horizontal',
    }"
  >
    <UAvatar
      v-if="props.icon !== undefined"
      :icon="props.icon"
      size="lg"
      :ui="{
        root: `size-10 rounded-md ${iconBackground}`,
        icon: `size-7 ${iconText}`,
      }"
    />
    <template v-if="props.orientation === 'horizontal'">
      <div class="flex flex-col gap-0.5">
        <slot name="title">
          <span
            v-if="props.title !== undefined"
            class="text-xl font-bold text-text-neutral-lv1 line-clamp-1"
          >
            {{ props.title }}
          </span>
        </slot>

        <slot name="description">
          <span
            v-if="props.description !== undefined"
            class="text-sm font-medium leading-sm text-text-neutral-lv2 line-clamp-1"
          >
            {{ props.description }}
          </span>
        </slot>
      </div>
    </template>
    <template v-if="props.orientation === 'vertical'">
      <slot name="title">
        <span
          v-if="props.title !== undefined"
          class="text-lg font-bold text-text-neutral-lv1 line-clamp-1"
        >
          {{ props.title }}
        </span>
      </slot>
      <slot name="description">
        <span
          v-if="props.description !== undefined"
          class="text-sm font-medium leading-sm text-text-neutral-lv2 line-clamp-1"
        >
          {{ props.description }}
        </span>
      </slot>
    </template>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  icon?: string;
  title?: string;
  description?: string;
  orientation?: "horizontal" | "vertical";
  color?: "primary" | "success" | "warning" | "info" | "error" | "neutral"
}

const props = withDefaults(defineProps<Props>(), {
  orientation: "horizontal",
  color: "primary",
  icon: undefined,
  title: undefined,
  description: undefined,
});

const iconBackground = computed(
  () =>
    ({
      primary: "bg-bg-primary",
      success: "bg-bg-green",
      warning: "bg-bg-amber",
      info: "bg-bg-primary",
      error: "bg-bg-red",
      neutral: "bg-bg-neutral",
    })[props.color],
);

const iconText = computed(
  () =>
    ({
      primary: "text-icon-primary",
      success: "text-icon-green",
      warning: "text-icon-amber",
      info: "text-icon-primary",
      error: "text-icon-red",
      neutral: "text-icon-neutral",
    })[props.color],
);
</script>

<style></style>
